import React, {useState} from 'react';
import Modal from "react-modal";
import PropTypes from "prop-types";
import {DiffEditor} from "@monaco-editor/react";
import _ from "lodash";

const PeriodReleaseModal = ({row}) => {
    const [isModalOpen, updateIsModalOpen] = useState(false);
    const isComparison = !_.isEmpty(row?.previousRecord);

    return (
        <>
            <button className={'button tertiary'} onClick={async () => {
                const {ensureMonacoConfigured} = await import("./monacoWorkerSetup");
                await ensureMonacoConfigured();
                updateIsModalOpen(true);
            }}>
                View Record
            </button>
            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => updateIsModalOpen(false)}
                ariaHideApp={false}
                className={`Modal audit-modal ${isComparison ? 'comparison-modal' : ''}`}>
                <>
                    <br/>
                    <h2>{`Details: ${row.action} on ${row.timestamp} by ${row.user}`}</h2>
                    <div className={'editor-and-buttons-side-by-side-container'}>
                        <DiffEditor
                            height="500px"
                            theme={"vs-dark"}
                            language="json"
                            original={JSON.stringify(row.record, null, 2)}
                            modified={isComparison ? JSON.stringify(row.previousRecord, null, 2) : JSON.stringify(row.record, null, 2)}
                            keepCurrentModifiedModel={true}
                            keepCurrentOriginalModel={true}
                            options={{
                                readOnly: true,
                                renderSideBySide: isComparison,
                                automaticLayout: true,
                                minimap: { enabled: false }
                            }}
                        />
                    </div>
                </>
                <div className={"right-things"}>
                    <button className="button cancel modal-button" type="button" name="close"
                            onClick={() => updateIsModalOpen(false)}>
                        Close
                    </button>
                </div>
            </Modal>
        </>
    );
};

PeriodReleaseModal.propTypes = {
    row: PropTypes.object.isRequired,
};

export default PeriodReleaseModal;